import { OrganizationInfo, OrganizationMember } from '../types';
import apiRequest from './apiRequest';

export default async function getOrganization(organizationID: string) {
  return apiRequest<{
    organizationInfo: OrganizationInfo;
    members: OrganizationMember[];
  }>('user', `/organization/${organizationID}`);
}
